import { Api } from "@/utils/http/types";
import { RequestEnum } from "@/enums/httpEnum";

const ArticleApis = {
  getArticleByCate: new Api({
    url: "/api/article/getArticleByCate",
    desc: "根据目录ID查询文章列表",
    method: RequestEnum.GET
  }),
  selectArticleById: new Api({
    url: "/api/article/selectById",
    desc: "根据ID查询文章",
    method: RequestEnum.GET
  }),
  selectAllArticle: new Api({
    url: "/api/article/selectAll",
    desc: "查询所有文章",
    method: RequestEnum.GET
  }),
  selectPageArticle: new Api({
    url: "/api/article/selectByPage",
    desc: "分页查询文章",
    method: RequestEnum.GET
  }),
  saveOrUpdateArticle: new Api({
    url: "/api/article/saveOrUpdate",
    desc: "保存或更新文章",
    method: RequestEnum.POST
  }),
  deleteArticle: new Api({
    url: "/api/article/delete",
    desc: "删除文章",
    method: RequestEnum.DELETE
  })
};

export default ArticleApis;

export interface Article {
  id?: number;
  title?: string;
  description?: string;
  content: string;
  status?: number;
  categoryId?: number;
  createTime?: string;
  updateTime?: string;
}
